import styled, { useTheme } from 'styled-components';

import { min } from '../../../utils/breakpoints';
import textOrPlaceholder from '../../../utils/textOrPlaceholder';
import StyledTitle from '../../Styled/StyledTitle';

const Container = styled.div``;

const Title = styled(StyledTitle)`
  margin-bottom: 0;
`;

const InfoCard = styled.div`
  border: 1px solid ${(props) => props.theme.colors.light};
  border-radius: 8px;
  padding: 10px 16px;

  ${min.sm} {
    display: flex;
    align-items: center;
  }
`;

const CardsContainer = styled.div`
  margin-top: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const InfoContent = styled.div`
  flex: 1;
`;

const Label = styled.p`
  font-size: 14px;
  margin-bottom: 0;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const Value = styled.p`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  text-align: center;

  ${min.sm} {
    text-align: left;
    font-size: 16px;
  }
`;

const GridInfo = styled.div`
  display: flex;
  justify-content: center;

  ${min.sm} {
    justify-content: flex-start;
  }
`;

const GridColumn = styled.div`
  padding: 0 30px;
`;

const FirstGridColumn = styled(GridColumn)`
  border-right: 1px solid ${(props) => props.theme.colors.light};

  ${min.sm} {
    padding-left: 0;
  }
`;

const TodaySoFar = ({ todaySoFarData }) => {
  const theme = useTheme();

  return (
    <Container>
      <CardsContainer>
        <Title>Today so far</Title>
        <InfoCard>
          <div className={'svg-icon solar-icon'}>
            <img src={theme.icons.solar} alt="Solar" />
          </div>
          <InfoContent>
            <Label>Solar generated:</Label>
            <Value>
              {textOrPlaceholder(
                todaySoFarData?.solar_generation,
                (todaySoFarData?.solar_generation / 1000)?.toFixed(2)
              )}{' '}
              kWh
            </Value>
          </InfoContent>
        </InfoCard>
        <InfoCard>
          <div className={'svg-icon consumption-icon'}>
            <img src={theme.icons.electricity} alt="Consumption" />
          </div>
          <InfoContent>
            <Label>Household consumption:</Label>
            <Value>
              {textOrPlaceholder(
                todaySoFarData?.load_consumption,
                (todaySoFarData?.load_consumption / 1000)?.toFixed(2)
              )}{' '}
              kWh
            </Value>
          </InfoContent>
        </InfoCard>
        <InfoCard>
          <div className={'svg-icon grid-icon'}>
            <img src={theme.icons.grid} alt="Grid" />
          </div>
          <InfoContent>
            <GridInfo>
              <FirstGridColumn>
                <Label>Exported:</Label>
                <Value>
                  {textOrPlaceholder(todaySoFarData?.exported, (todaySoFarData?.exported / 1000)?.toFixed(2))} kWh
                </Value>
              </FirstGridColumn>
              <GridColumn>
                <Label>Imported:</Label>
                <Value>
                  {textOrPlaceholder(todaySoFarData?.imported, (todaySoFarData?.imported / 1000)?.toFixed(2))} kWh
                </Value>
              </GridColumn>
            </GridInfo>
          </InfoContent>
        </InfoCard>
      </CardsContainer>
    </Container>
  );
};

export default TodaySoFar;
